import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { ButtonV2 } from "src/components/ButtonV2/ButtonV2.tsx";
import { Trans, useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const LanguageChangeConfirmModal = ({
  onClose,
  onConfirm,
  language,
}: {
  onClose: () => void;
  onConfirm: (copy: boolean) => void;
  language: {
    value: string;
    label: string;
  };
}) => {
  const { t } = useTranslation(TranslationNamespaceEnum.FormComponent);
  return (
    <ModalV3 onClose={onClose}>
      <ModalV3.Positioner>
        <ModalV3.Content>
          <ModalV3.CloseTrigger />
          <ModalV3.Header>
            <ModalV3.Title>
              {t("confirmLanguageChangeModal.title")}
            </ModalV3.Title>
          </ModalV3.Header>
          <ModalV3.Body
            style={{
              width: 600,
              textAlign: "center",
            }}
          >
            <TextV2 variant={"body1"}>
              <Trans
                i18nKey="confirmLanguageChangeModal.subTitle"
                t={t}
                ns={TranslationNamespaceEnum.FormComponent}
                values={{
                  language: language.label,
                }}
                components={{
                  bold: <TextV2 variant={"body1"} fontWeight={"semibold"} />,
                }}
              />
            </TextV2>
          </ModalV3.Body>
          <ModalV3.Footer>
            <ModalV3.FooterButtons>
              <ButtonV2
                variant="filled"
                skin="info"
                style={{
                  minWidth: 120,
                }}
                onClick={() => onConfirm(true)}
              >
                {t("confirmLanguageChangeModal.actions.copy")}
              </ButtonV2>

              <ButtonV2
                variant="outlined"
                skin="info"
                style={{
                  minWidth: 120,
                }}
                onClick={() => onConfirm(false)}
              >
                {t("confirmLanguageChangeModal.actions.continue")}
              </ButtonV2>
            </ModalV3.FooterButtons>
          </ModalV3.Footer>
        </ModalV3.Content>
      </ModalV3.Positioner>
    </ModalV3>
  );
};
